import React from 'react';

export default function FloatingToast({ message, onDismiss }) {
  if (!message) return null;

  const isError =
    String(message).toLowerCase().includes('error') ||
    String(message).toLowerCase().includes('failed');

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center pointer-events-none">
      <div
        className={`pointer-events-auto w-[min(92vw,560px)] rounded-lg shadow-xl border px-4 py-3 text-sm flex items-start gap-3 ${
          isError
            ? 'bg-rose-50 border-rose-200 text-rose-800'
            : 'bg-emerald-50 border-emerald-200 text-emerald-900'
        }`}
        role="status"
        aria-live="polite"
      >
        <div className="flex-1">{message}</div>
        {onDismiss && (
          <button
            type="button"
            onClick={onDismiss}
            className="text-xs font-semibold uppercase tracking-wide opacity-70 hover:opacity-100"
            aria-label="Dismiss message"
          >
            Close
          </button>
        )}
      </div>
    </div>
  );
}
